import dayjs from 'dayjs';
import React from 'react';

import Icon from '@components/Icon/Icon';
import { EIcons } from '@enums/icons.enum';
import { EStyles } from '@enums/style.enum';
import { TimeFormat } from '@enums/timeFormat.enum';

import classes from './DateAndTime.module.scss';

interface Props {
	date: number;
	bold?: boolean;
	size?: number;
}

const DateAndTime: React.FC<Props> = ({ date, bold, size = 18 }: React.PropsWithChildren<Props>) => {
	return (
		<div className={classes['container']}>
			<div className={classes['headerIconElementContainer']}>
				<Icon name={EIcons.Date} size={size} color="var(--text)" style={{ marginRight: 3 }} />
				<p className={`${classes['headerText']} ${bold ? classes['bold'] : EStyles.emptyQuote}`} style={{ fontSize: size - 2 }}>
					{dayjs.unix(date).format(TimeFormat.DateMonthDayFullYear)}
				</p>
			</div>
			<div className={classes['headerIconElementContainer']}>
				<Icon name={EIcons.Time} size={size + 2} color="var(--text)" style={{ marginTop: 2 }} />
				<p className={`${classes['headerText']} ${bold ? classes['bold'] : EStyles.emptyQuote}`} style={{ fontSize: size - 2 }}>
					{dayjs.unix(date).format(TimeFormat.Time24Hour)}
				</p>
			</div>
		</div>
	);
};

export default DateAndTime;
